var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarChartStart = function SvgBarChartStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 41 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m7.086 8.414-6.5 6.5A2 2 0 0 0 0 16.33V19.5a2 2 0 0 0 2 2h37a2 2 0 0 0 2-2V16.33a2 2 0 0 0-.586-1.415l-13.5-13.5a2 2 0 0 0-2.828 0l-9.172 9.172a2 2 0 0 1-2.828 0L9.914 8.414a2 2 0 0 0-2.828 0"
  })));
};
export default SvgBarChartStart;